import { Inject, Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSubscriptionService } from '../services/auth-subscription.service';
import { take } from 'rxjs';
import { LocalStorageWrapper } from '../classes/local-storage-wrapper.class';
import { AuthenticationService_TOKEN } from '../tokens/injection-tokens';
import { IAuthenticationService } from '../interfaces/authentication-service.interface';

@Injectable({ providedIn: 'root' })
class AuthGuardService {
    private isUserAuthenticated: boolean = false;
    constructor(
        @Inject(AuthenticationService_TOKEN)
        private authenticationService: IAuthenticationService,
        private router: Router,
        private authSubscriptionService: AuthSubscriptionService
    ) {}

    canActivate(url: string): boolean | Promise<boolean> {
        const token = LocalStorageWrapper.getToken();

        if (!token || token === '') {
            this.authenticationService.logout();
            return false;
        }

        this.authSubscriptionService.authChanged.pipe(take(1)).subscribe(authState => {
            this.isUserAuthenticated = authState;
        });

        if (this.isUserAuthenticated) {
            return true;
        }

        return this.authenticationService.tryRefreshingTokens().then(refreshSucceded => {
            if (refreshSucceded) {
                this.authSubscriptionService.sendAuthStateChangeNotification(true);
                return true;
            } else {
                this.authenticationService.logout();
                return false;
            }
        });
    }
}

export const AuthGuard: CanActivateFn = (route, state): boolean | Promise<boolean> => {
    return inject(AuthGuardService).canActivate(state.url.split('?')[0]);
};
